module.exports = __webpack_public_path__ + "static/media/5_Identify-Chime-Type-Analog.3183622c.svg";